import { ASSETS_LOCATIONS, getAssetsUrl } from '../../../utilities/constants';

export const LOYALTY_IMAGES = {
  ADVENTURE_BUCK_COIN: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'v-adventure-buck-coin.svg'),
  ADVENTURE_BUCK_COIN_WHITE: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'v-2-adventure-buck-coin-white.svg'),
  ADVENTURE_BUCK_COIN_GREEN: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'voyagers-icon.svg'),
  VOYAGER_ICON_FOREST_GREEN: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'VoyagersIcon-forest-green.svg'),
  VOYAGER_ICON_LOGGED_IN: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'voyagers-icon-logged-in.svg'),
  ADVENTURE_BUCK_COIN_MOSS: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'voyagers-icon-moss.svg'),
  VOYAGER_ICON_FOREST_GREEN_WHITE: getAssetsUrl(ASSETS_LOCATIONS.SVG, 'Voyagers-forestGreen-white.svg')
};
